module.exports = __webpack_public_path__ + "media/images/where-assets-pisos-a-7921ec07a16205f7f194e2dfb6376a1d.svg";